export default function Toast({ message }: { message: string }) {
  if (!message) return null;
  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[100] animate-fade-up">
      <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-foreground-950 text-background-50 text-sm font-medium">
        <i className="ri-checkbox-circle-fill text-primary-400" />
        {message}
      </div>
    </div>
  );
}